import React, { useEffect, useRef,useState } from "react"
import './assets/css/bootstrap.min.css';
import './assets/css/bootstrap-toggle.css';
import "ol/ol.css"
import "ol-ext/dist/ol-ext.css"
import './assets/css/ensam.css';
// Import Swiper styles
import 'swiper/css';
import $ from "jquery";

import MapComponent from "./Map/MapComponent";

function App() {

  // Choix fond de carte
  $(document).ready(function() {
    $(".choix-fond .actif, .choix-fond a").click(function() {
      $(".choix-fond").toggleClass("visible");
      $(".choix-fond").toggleClass("on");
    });


    // Menu principal gauche
    document.getElementById('toggleSidebar').addEventListener('click', function () {
      document.body.classList.toggle('collapsed');
    });
    // Affichage des infos supplémentaires si toggle activé
    $('.toggle-min').on('change', function() {
      var $blocToggle = $(this).closest('.bloc-toggle');
      if ($(this).prop('checked')) {
        $blocToggle.find('.elt-sup').addClass('on');
      } else {
        $blocToggle.find('.elt-sup').removeClass('on');
      }
    });

    // Affichage sous-menu thématique
    $('.acces-thematique').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('on');
      $(this).next('.ss-menu-thematique').toggleClass('visible');
    });

  });


  return (
    <MapComponent />
  );
}

export default App;
